import React, { Component } from "react";
import classNames from "classnames";
import {
  IPageHeaderWrapperProps,
  IPageHeaderWrapperState,
} from "./PageHeaderWrapper.interfaces";

import { addStyleXY } from "../../utilities/Styling";

import "./PageHeaderWrapper.scss";

class PageHeaderWrapper extends Component<
  IPageHeaderWrapperProps,
  IPageHeaderWrapperState
> {
  render() {
    const {
      children,
      className,
      autoOverflow,
      autoOverflowX,
      autoOverflowY,
      noGutter,
      noGutterX,
      noGutterY,
      useMargin,
      ...rest
    } = this.props;

    const Overflow = addStyleXY(
      "auto-overflow",
      autoOverflow,
      autoOverflowX,
      autoOverflowY
    );
    const NoGutter = addStyleXY(
      useMargin ? "no-margin" : "no-padding",
      noGutter,
      noGutterX,
      noGutterY
    );

    return (
      <div
        {...rest}
        className={classNames(
          "c-page-header-wrapper",
          {
            "use-margin": useMargin,
          },
          Overflow,
          NoGutter,
          className
        )}
      >
        {children}
      </div>
    );
  }
}
export default PageHeaderWrapper;
